class ProductCardSwatches {
  constructor() {
    document.addEventListener('pointerover', this.onActivate.bind(this));
    document.addEventListener('focusin', this.onActivate.bind(this));
  }

  onActivate(event) {
    const swatch = event.target.closest('[data-product-card-swatch]');
    if (!swatch) return;

    const wrapper = swatch.closest('.product-card-wrapper');
    const image = wrapper?.querySelector('[data-product-card-primary-image]');
    if (!wrapper || !image) return;

    this.updateSelectedSwatch(wrapper, swatch);

    if (!swatch.dataset.productCardSwatchSrc) return;

    image.src = swatch.dataset.productCardSwatchSrc;

    if (swatch.dataset.productCardSwatchSrcset) {
      image.srcset = swatch.dataset.productCardSwatchSrcset;
    }

    if (swatch.dataset.productCardSwatchWidth) {
      image.width = swatch.dataset.productCardSwatchWidth;
    }

    if (swatch.dataset.productCardSwatchHeight) {
      image.height = swatch.dataset.productCardSwatchHeight;
    }

    if (swatch.dataset.productCardSwatchAlt) {
      image.alt = swatch.dataset.productCardSwatchAlt;
    }
  }

  updateSelectedSwatch(wrapper, swatch) {
    wrapper.querySelectorAll('[data-product-card-swatch-selected]').forEach((selectedSwatch) => {
      selectedSwatch.removeAttribute('data-product-card-swatch-selected');
    });

    swatch.setAttribute('data-product-card-swatch-selected', 'true');
  }
}

new ProductCardSwatches();
